export { default as BattleNetIcon } from '~icons/mdi/battlenet';
